<template>
  <div class="pagerMain">

    <div v-if="mainData['console'] && mode == 'E'" style="width: 100%; height: 20px; display: flex; align-items: center; justify-content: space-between;">
      <div style="width: 100%; height: 20px; display: flex; align-items: center; justify-content: flex-start;">
        <div :style="{ 'width': '20px', 'height': '20px', 'background-color': (mainData['pageLoaded'] ? 'green' : 'red'),
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'color': '#ffff' }">L</div>
        <div :style="{ 'width': '20px', 'height': '20px', 'background-color': (mouseData['mouseDown'] ? 'green' : 'red'),
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'color': '#ffff' }">D</div>
        <div :style="{ 'width': '20px', 'height': '20px', 'background-color': (mouseData['mouseMove'] ? 'green' : 'red'),
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'color': '#ffff' }">M</div>
        <div :style="{ 'width': '20px', 'height': '20px', 'background-color': (editorData['editorResize'] ? 'green' : 'red'),
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'color': '#ffff' }">RS</div>
        <div :style="{ 'width': '20px', 'height': '20px', 'background-color': (pagerData['mouseOver'] ? 'green' : 'red'),
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'color': '#ffff' }">MO</div>
      </div>
      <div style="width: auto; height: 20px; display: flex; align-items: center; justify-content: flex-end;">
        <input type="text" v-model="mainData['saveName']" :style="{ 'width': '160px', 'height': '20px', 'font-size': '12px',
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center' }"/>
        <button @click="testBtn('saveData')" :style="{ 'width': 'auto', 'height': '20px',
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'white-space': 'nowrap'}"> Save </button>
        <button @click="testBtn('print')" :style="{ 'width': 'auto', 'height': '20px', 
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'white-space': 'nowrap' }"> Print </button>
        <button @click="testBtn('reset')" :style="{ 'width': 'auto', 'height': '20px', 
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'white-space': 'nowrap' }"> Reset </button>
        <button @click="testBtn('getRatio')" :style="{ 'width': 'auto', 'height': '20px', 
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'white-space': 'nowrap' }"> Ratio </button>
        <button @click="testBtn('getData')" :style="{ 'width': 'auto', 'height': '20px',
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'white-space': 'nowrap' }"> Get Data </button>
        <button @click="testBtn('loadData')" :style="{ 'width': 'auto', 'height': '20px', 'background-color': (mainData['showData'] ? '#0f08' : ''),
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'white-space': 'nowrap' }"> Preview </button>
        <button @click="pageAutoGenerate()" :style="{ 'width': 'auto', 'height': '20px', 
            'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '12px', 'white-space': 'nowrap' }"> Check </button>
      </div>  

      <div style="position: fixed; right: 20px; top: 100px; border: solid 1px gray; width: 300px; height: auto;
          display: flex; flex-direction: column; align-items: flex-start; justify-content: center;
          font-size: 12px; padding: 0 4px;">
          <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
            <div>Zoom Value</div>
            <div> {{toolbarData['zoomLevel']}} </div>
          </div>
          <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
            <div>Zoom Inverse</div>
            <div> {{toolbarData['zoomLevelInv']}} </div>
          </div>
          <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
            <div>Mouse Last Click X</div>
            <div> {{mouseData['posX']}} </div>
          </div>
          <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
            <div>Mouse Last Click Y</div>
            <div> {{mouseData['posY']}} </div>
          </div>
          <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
            <div>Scroll Top</div>
            <div> {{mouseData['offsetScrollTop']}} </div>
          </div>
          <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
            <div>Scroll Left</div>
            <div> {{mouseData['offsetScrollLeft']}} </div>
          </div>
          <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
            <div>Offset X</div>
            <div> {{mouseData['offsetX']}} </div>
          </div>
          <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
            <div>Offset Y</div>
            <div> {{mouseData['offsetY']}} </div>
          </div>
          <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
            <div>Page Selected</div>
            <div> {{this.editorData['pageSel']}} </div>
          </div>
      </div>
    </div>

    <div class="pagerToolbar" v-if="mode == 'P'" :style="{ 'padding': '0 0 4px 0' }">
      <div class="pagerToolbarSection">
        <div class="pagerRow">
          <div style="border: solid 1px lightgray; padding: 0 4px; width: 100%; color: gray;"> {{Math.round(toolbarData['zoomLevel'] * 100) + '%'}} </div>
        </div>
        <div class="pagerRow">
            <button @click="toolbarBtn('zoomReset')" style="width: 60px; margin: 0 10px 0 0;"> Reset </button>
          <div class="pagerCol">
            <button @click="toolbarBtn('zoomSub')"> - </button>
            <button @click="toolbarBtn('zoomAdd')"> + </button>
          </div>
        </div>
      </div>
      
      <div class="pagerToolbarFunctions">
        <div class="pagerToolbarCol">
          <button class="pagerToolbarFunctionsBtn" @click="toolbarBtn('cancel')" > Cancel </button>
        </div>
        <div class="pagerToolbarCol">
          <button class="pagerToolbarFunctionsBtn" @click="toolbarBtn('print')" :disabled="pagerData['pages']['length'] <= 0"> Print </button>
        </div>
      </div>
    </div>

    <div class="pagerToolbar" v-if="mode == 'E'">
      <div class="pagerToolbarSection">
        <div class="pagerRow">
          <select class="pagerTextFamily" v-model="toolbarData['textFamily']" @change="toolbarBtn()">
            <option v-for="t in toolbarData['textFamilyData']" :key="t['value']" :value="t['value']">{{t['desc']}}</option>
          </select>
          <input class="pagerTextSize" type="number" v-model="toolbarData['textSize']" @input="toolbarBtn()"/>
        </div>
        <div class="pagerRow">
          <div class="pagerCol">
            <button :class="[(toolbarData['textAlign'] == 'top' ? 'selected' : '')]"
                @click="toolbarBtn('align', 'top')"> <svg viewBox="0 0 500 500"> <path :d="toolbarData['icon']['alignT']"/> </svg> </button>
            <button :class="[(toolbarData['textAlign'] == 'center' ? 'selected' : '')]"
                @click="toolbarBtn('align', 'center')"> <svg viewBox="0 0 500 500"> <path :d="toolbarData['icon']['alignC']"/> </svg> </button>
            <button :class="[(toolbarData['textAlign'] == 'bottom' ? 'selected' : '')]"
                @click="toolbarBtn('align', 'bottom')"> <svg viewBox="0 0 500 500"> <path :d="toolbarData['icon']['alignB']"/> </svg> </button>
          </div>
          <div class="pagerCol">
            <button :class="[(toolbarData['textWeight'] == 'bold' ? 'selected' : '')]" @click="toolbarBtn('bold')"> B </button>
          </div>
        </div>
        <div class="pagerRow">
          <div class="pagerCol">
            <button :class="[(toolbarData['textJustify'] == 'left' ? 'selected' : '')]"
                @click="toolbarBtn('justify', 'left')"> <svg viewBox="0 0 500 500"> <path :d="toolbarData['icon']['justifyL']"/> </svg> </button>
            <button :class="[(toolbarData['textJustify'] == 'center' ? 'selected' : '')]"
                @click="toolbarBtn('justify', 'center')"> <svg viewBox="0 0 500 500"> <path :d="toolbarData['icon']['justifyC']"/> </svg> </button>
            <button :class="[(toolbarData['textJustify'] == 'right' ? 'selected' : '')]"
                @click="toolbarBtn('justify', 'right')"> <svg viewBox="0 0 500 500"> <path :d="toolbarData['icon']['justifyR']"/> </svg> </button>
          </div>
          <div class="pagerCol">
            <input class="pagerTextColor" type="color" v-model="toolbarData['textColor']" @input="toolbarBtn()"/>
          </div>
        </div>

        <div class="pagerToolbarSectionTitle"> Text Style </div>
      </div>
      
      <div class="pagerToolbarSection">
        <div class="pagerRow">
          <div style="border: solid 1px lightgray; padding: 0 4px; width: 100%; color: gray;"> {{Math.round(toolbarData['zoomLevel'] * 100) + '%'}} </div>
        </div>
        <div class="pagerRow">
            <button @click="toolbarBtn('zoomReset')" style="width: 60px; margin: 0 10px 0 0;"> Reset </button>
          <div class="pagerCol">
            <button @click="toolbarBtn('zoomSub')"> - </button>
            <button @click="toolbarBtn('zoomAdd')"> + </button>
          </div>
        </div>

        <div class="pagerToolbarSectionTitle"> Zoom Settings </div>
      </div>
      
      <div class="pagerToolbarSection">
        <select class="pagerFieldTypeSelect" v-model="toolbarData['type']" @change="toolbarBtn()">
          <option selected disabled value=""> Select Field Type </option>
          <option v-for="t in toolbarData['typeData']" :key="t['value']" :value="t['value']">{{t['desc']}}</option> 
        </select>
        
        <div class="pagerToolbarSectionTitle"> Field Settings </div>
      </div>
      
      <div class="pagerToolbarSection">
        <select class="pagerFormSelect" ref="pagerFormSelect" @change="toolbarBtn('loadImg')">
          <option selected disabled value=""> Select Background </option>
          <option v-for="t in toolbarData['forms']" :key="t['file']" :value="t['file']">{{t['file']}}</option>
        </select>

        <div class="pagerToolbarSectionTitle"> Load Settings </div>
      </div>

      <div class="pagerToolbarFunctions">
        <div class="pagerToolbarCol">
          <button class="pagerToolbarFunctionsBtn" @click="toolbarBtn('explorer', 'form')"> Manage Forms </button>
          <button class="pagerToolbarFunctionsBtn" @click="toolbarBtn('explorer', 'image')"> Manage Images </button>
        </div>
        <div class="pagerToolbarCol">
          <button class="pagerToolbarFunctionsBtn" @click="toolbarBtn('saveSave')"> Save </button>
          <button class="pagerToolbarFunctionsBtn" @click="toolbarBtn('print')"> Print </button>
          <button class="pagerToolbarFunctionsBtn" @click="toolbarBtn('reset')"> Reset </button>
        </div>
      </div>
    </div>

    <div class="pagerContent" ref="pagerContent" id="pagerContent"
        @mousemove="pagerMouseMove($event)"
        @mouseup="pagerMouseUp($event)"
        @mousedown="pagerMouseDown($event)"
        @mouseover="pagerMouseOver($event)"
        @mouseleave="pagerMouseLeave($event)"
        @scroll="pagerScroll($event)">

      <!-- Dot Indicator of last click position -->
      <div v-if="mainData['console'] && mode == 'E'" :style="{ 'left': ((mouseData['posX']) - 1 + 'px'), 'top': ((mouseData['posY']) - 1 + 'px'), 
          'border': 'solid 1px red', 'width': '2px', 'height': '2px', 'position': 'absolute', 'z-index': '999',
          'user-select': 'none', 'pointer-events': 'none' }"></div>

      <!-- Field Property Editor -->
      <div class="editorMain" id="editorMain" v-if="editorData['show'] && mode == 'E'" :style="{ 
          'width': (editorData['width'] + 'px'),
          'height': (editorData['height'] + 'px'),
          'top': (editorData['posY'] + 'px'),
          'left': (editorData['posX'] + 'px') }">

        <div class="editorResize" id="editorMain" v-if="editorData['editorResizeShow']" :style="{
            'pointer-events': (mouseData['mouseDown'] ? 'none' : '') }"
            @mousedown="editorBtn('resizeMouseDown')"></div>

        <div class="editorTextMain" id="editorMain" v-if="editorData['editorTextShow']">
          <div class="editorText" id="editorMain" :style="{  
              'top': ((editorData['height'] + 10) + 'px'),
              'right': ((editorData['posX'] + (editorData['width'] / 2) > ((pageData['width'] * (1 / 0.8)) / 2)) ? '-1px' : ''),
              'left': ((((editorData['posX'] + 350) - editorData['pagePosX'] - (pageData['width'] * toolbarData['zoomLevel'])) < 0 ? -1 : -((editorData['posX'] + 352) - editorData['pagePosX'] - (pageData['width'] * toolbarData['zoomLevel']))) + 'px'),
              'pointer-events': (editorData['editorTextShow'] ? 'all' : '') }">
            
            <textarea class="editorTextarea" id="editorMain" ref="editorTextarea" v-model="editorData['value']" @input="editorBtn('textarea')"></textarea>
            <select class="editorTextselect" id="editorMain" ref="editorTextselect" size="3" @click="editorBtn('textselect')">
              <option id="editorMain" v-for="k in mainData['keys']" :key="k['value']" :value="k['value']">{{k['desc']}}</option>
            </select>
          </div>
        </div>
        
        <div class="editorTableMain" id="editorMain" v-if="editorData['editorTableShow']">
          <div class="editorTableCellKeys" v-if="editorData['tableKey']" :style="{ 
              'width': (editorData['width'] + 'px'),
              'pointer-events': (editorData['editorTableShow'] ? 'all' : '') }">
            <select class="editorTableCellselect" id="editorMain" ref="editorTablekeyselect" v-for="r in parseInt(editorData['tableCol'])" :key="'tableCell' + r" @change="editorBtn('tablekeyselect')">
              <option selected disabled value=""> Select Cell Key </option>
              <option id="editorMain" v-for="k in editorData['tableCellKeys']" :key="k['value']" :value="k['value']">{{k['desc']}}</option>
            </select>
          </div>

          <div class="editorTable" id="editorMain" :style="{ 
              'top': ((editorData['height'] + 10) + 'px'),
              'left': ((((editorData['posX'] + 350) - editorData['pagePosX'] - (pageData['width'] * toolbarData['zoomLevel'])) < 0 ? -1 : -((editorData['posX'] + 352) - editorData['pagePosX'] - (pageData['width'] * toolbarData['zoomLevel']))) + 'px'),
              'pointer-events': (editorData['editorTableShow'] ? 'all' : '') }">

            <div class="editorTableRow">
              <select class="editorTableselect" id="editorMain" ref="editorTableselect" v-model="editorData['tableKey']" @change="editorBtn('tableselect')">
                <option selected disabled value=""> Select Table Key </option>
                <option id="editorMain" v-for="k in mainData['lists']" :key="k['value']" :value="k['value']">{{k['desc']}}</option>
              </select>
              <div class="editorTableCol">
                <div class="editorTableLabel"> Columns </div>
                <input class="editorTableInput" id="editorMain" type="number" min="1" v-model="editorData['tableCol']" @input="editorBtn('tablecol')"/>
              </div>
            </div>
            <div class="editorTableRow">
              <div class="editorTableCol">
                <button :class="[(editorData['tableBorder'] ? 'selected' : '')]" id="editorMain"
                    @click="editorBtn('tableborder')"> <svg viewBox="0 0 500 500"> <path :d="toolbarData['icon']['border']"/> </svg> </button>
              </div>
              <div class="editorTableCol">
                <div class="editorTableLabel"> Rows </div>
                <input class="editorTableInput" id="editorMain" type="number" min="1" v-model="editorData['tableRow']" @input="editorBtn('tablerow')"/>
              </div>
            </div>
            <div class="editorTableRow">
              <div class="editorTableCol">
                <button :class="[(editorData['tableTrigger'] ? 'selected' : '')]" id="editorMain"
                    @click="editorBtn('tabletrigger')"> C </button>
                <input class="editorTableInput" id="editorMain" type="text" placeholder="Trigger" v-model="editorData['tableTriggerText']"
                    :disabled="!editorData['tableTrigger']" @input="editorBtn('tabletriggertext')"/>
              </div>
              <div class="editorTableCol">
                <div class="editorTableLabel"> Sequence </div>
                <input class="editorTableInput" id="editorMain" type="number" min="1" v-model="editorData['tableSeq']" @input="editorBtn('tableseq')"/>
              </div>
            </div>
            
            <!-- Additional Functions to Left -->
            <div class="editorTableFunctions">
              <button id="editorMain" 
                  @click="fieldDuplicate($event, editorData['fieldSel'])"> <svg viewBox="0 0 500 500"> <path :d="toolbarData['icon']['copy']"/> </svg> </button>
            </div>
          </div>

          <div class="editorTableSeq" :style="{
              'max-height': ((editorData['height']) + 'px'),
              'right': ((editorData['width'] + 5) + 'px')}"> 
            <div class="editorTableSeqLabel" v-for="s in parseInt(editorData['tableRow'])" :key="'seqLabel' + s" :style="{
                'max-height': ((editorData['height'] / editorData['tableRow']) + 'px'), 
                'font-size': ((((editorData['height'] / editorData['tableRow']) > 12 ? 12 : (editorData['height'] / editorData['tableRow'])) * 0.8) + 'px'),
                'line-height': (((editorData['height'] / editorData['tableRow']) > 12 ? 12 : (editorData['height'] / editorData['tableRow'])) + 'px') }"> 
              {{parseInt(editorData['tableSeq']) + (s - 1)}}
            </div>
          </div>

          
        </div>

      </div>

      <!-- Page Property Editor -->
      <div class="editorPageMain" id="editorMain" v-if="editorData['editorPageShow'] && editorData['pageSel'] && mode == 'E'" :style="{ 
          'min-width': (((pageData['width'] * 0.15) * ((toolbarData['zoomLevel'] - 1) > 0 ? toolbarData['zoomLevel'] : ((1 - toolbarData['zoomLevel']) > 0) ? 1.1 : 0)) + 'px'),
          'max-width': (((pageData['width'] * 0.2) * toolbarData['zoomLevel']) + 'px'),
          'top': ((editorData['pagePosY']) + 'px'),
          'left': ((editorData['pagePosX'] + (pageData['width'] * toolbarData['zoomLevel'])) + 'px'), }">
          <div class="editorPageLabel"> {{editorData['pageSel']}} </div>
          <button :class="['editorPageBtn' , (editorData['pageTrigger'] ? 'selected' : '')]" 
              @click="pageEditorBtn('pagetrigger')"> C </button>
          <input type="text" placeholder="Trigger" v-model="editorData['pageTriggerText']"
              :disabled="!editorData['pageTrigger']" @input="pageEditorBtn('pagetriggertext')"/>
      </div>

      <div class="pageMargin" :style="{ 'min-width': (((pageData['width'] * (mode == 'E' ? 0.04 : 0.09)) * (toolbarData['zoomLevel'] * 1.2)) + 'px') }"></div>
      <div class="pageViewer" ref="pageViewer">
        <div class="pageMain" :id="p['id']" :ref="p['id']" v-for="(p, i) in pagerData['pages']" :key="'page' + i" :style="{
              'position': 'relative',
              'background-size': '100% auto',
              'background-repeat': 'no-repeat',
              'background-position': 'center',
              'width': ((pageData['width'] * toolbarData['zoomLevel']) + 'px'),
              'height': ((pageData['height'] * toolbarData['zoomLevel']) + 'px') }"
            @mouseup="pageMouseUp($event, p['id'])"
            @mouseover="pageMouseOver($event, p['id'])"
            @mouseleave="pageMouseLeave($event, p['id'])">
          <div class="pageNumber" :style="{
              'padding': ('0 ' + ((4 * toolbarData['zoomLevel']) * pageData['textptpx']) + 'px'),
              'font-size': (((10 * toolbarData['zoomLevel']) * pageData['textptpx']) + 'px') }"> 
            Page {{(i + 1)}} of {{pagerData['pages']['length']}} 
          </div>
            
          <Field :class="['pageField', ((pagerData['fieldSel'] == f['id'] && pagerData['pageSel'] == p['id'] && !mainData['showData']) ? 'selected' : '')]" 
              :id="f['id']" :ref="f['id']" v-for="f in p['fields']" :key="f['id']" :style="{
              'position': 'absolute', 
              'width': ((f['width'] * toolbarData['zoomLevel']) + 'px'), 
              'height': ((f['height'] * toolbarData['zoomLevel']) + 'px'),
              'left': ((f['posX'] * toolbarData['zoomLevel']) + 'px'), 
              'top': ((f['posY'] * toolbarData['zoomLevel']) + 'px'),
              'pointer-events': (mouseData['mouseDown'] ? 'none' : '') }"
            :keyData="mainData['data']"
            :showKeyData="mainData['showData']"
            :pageData="pageData"
            :toolbarData="toolbarData"
            :fieldData="f"
            @mousedown="fieldMouseDown($event, f['id'])"/>
        </div>
      </div>

      <div class="pagePlaceholder" v-if="pagerData['pages']['length'] <= 0" :style="{
          'width': ((pageData['width'] * toolbarData['zoomLevel']) + 'px'),
          'height': ((pageData['height'] * toolbarData['zoomLevel']) + 'px') }">
        <div class="pagePlaceholderText" :style="{
            'width': ((pageData['width'] * toolbarData['zoomLevel'] * 0.65) + 'px'),
            'height': ((pageData['height'] * toolbarData['zoomLevel'] * 0.2) + 'px') }">
          {{this.mode == 'P' ? 'No Form Found' : 'No Page Found'}}
        </div>
      </div>
      <div class="pageMargin" :style="{ 'min-width': (((pageData['width'] * 0.09) * (toolbarData['zoomLevel'] * 1.2)) + 'px') }"></div>
    </div>

    <!-- Save Pop Up -->
    <div class="pagerSaveMain" v-if="mainData['saveShow']">
      <div class="pagerSave">
        <div class="pagerSaveTitle"> Save Form </div>
        <input class="pagerSaveInput" ref="pagerSaveInput" placeholder="Form Name" v-model="mainData['saveName']" @input="toolbarBtn('saveList')"/>
        <div class="pagerSaveList">
          <div class="pagerSaveItem" v-for="(j, i) in mainData['saveList']" :key="'item' + i"> {{j['file'].split('\.')[0]}} </div>
          <div class="pagerSaveItem" :style="{ 'justify-content': 'center', 'color': '#199400' }" v-if="mainData['saveList']['length'] <= 0"> No duplicates </div>
        </div>
        <div class="pagerSaveFunctions"> 
          <div class="pagerSaveReminder"> Using the same form name will override existing forms </div>
          <button class="pagerSaveFunctionsBtn" @click="toolbarBtn('saveConfirm')"> Save </button>
          <button class="pagerSaveFunctionsBtn" @click="toolbarBtn('saveCancel')"> Cancel </button>
        </div>
      </div>
    </div>
    
    <Explorer v-if="mainData['explorerShow']" :show.sync="mainData['explorerShow']" :page="mainData['explorerPage']"
        @formSelect="explorerFormSelect"/>

  </div>
</template>

<script>
/* eslint-disable */
import Pager from '@/components/reportDesigner/Pager.vue';
import Field from '@/components/reportDesigner/Field.vue';
import Explorer from '@/components/reportDesigner/Explorer.vue';

export default {
  name: 'reportDesigner',
  components: {
      Pager, Field, Explorer
  },
  props: {
    mode: { type: String, default: 'E' },
    form: { type: String, default: '' },
    data: { type: Object, default: function() { return null; }},
  },
  data() { 
    return {
      mainData: {
        'console': false,

        'explorerShow': false,
        'explorerPage': '',

        'saveShow': false,
        'saveList': [],
        'saveName': '',
        'saveNameOriginal': '',

        'pageLoaded': false,

        'showData': false,
        'data': {},
        'keys': [],
        'lists': [],

        'version': 1,
      },

      pageData: {
        'widthpx': 794,
        'heightpx': 1123,
        'widthmm': 210,
        'heightmm': 297,
        'textptpx':	1.3333333333333333333333333333333, 
        
        'whratio': 0,
        'ratio': 0,
        'ratioInv': 0,

        'width': 0,
        'height': 0,
      },

      pagerData: {
        'pages': [
          { 'id': 'page0', 
            'form': '', 
            'properties': {
              'pageTrigger': false,
              'pageTriggerText': '',
            }, 
            'fields': [],
            'version': 1,
          },
        ],

        'mouseOver': false,
      },

      toolbarData: {
        'textFamilyData': [
          { 'desc': 'Arial', 'value': 'Arial' },
          { 'desc': 'Courier', 'value': 'Courier' },
          { 'desc': 'Times New Roman', 'value': 'Times New Roman' },
          { 'desc': 'Verdana', 'value': 'Verdana' },
        ],
        'typeData': [
          { 'desc': 'Text', 'value': 'text' },
          { 'desc': 'Table', 'value': 'table' },
        ],

        'type': 'text',
        'textFamily': 'Arial',
        'textSize': 12,
        'textWeight': 'normal',
        'textColor': '#000000',
        'textJustify': 'left',
        'textAlign': 'top',

        'zoomLevel': 1,
        'zoomLevelInv': 0,
        'zoomLevelInit': 1,

        'forms': [],
        'jsons': [],
        
        
        'icon': {
          'justifyL': 'M50 250L450 250L450 270L50 270L50 250Z M50 130L230 130L230 150L50 150L50 130Z M50 370L330 370L330 390L50 390L50 370Z',
          'justifyC': 'M50 250L450 250L450 270L50 270L50 250Z M50 130L450 130L450 150L50 150L50 130Z M50 370L450 370L450 390L50 390L50 370Z',
          'justifyR': 'M50 250L450 250L450 270L50 270L50 250Z M270 130L450 130L450 150L270 150L270 130Z M170 370L450 370L450 390L170 390L170 370Z',

          'alignT': 'M50 195L50 190L450 190L450 195L50 195ZM50 125L50 120L450 120L450 125L50 125ZM50 55L50 50L450 50L450 55L50 55Z',
          'alignC': 'M50 322.5L50 317.5L450 317.5L450 322.5L50 322.5ZM50 252.5L50 247.5L450 247.5L450 252.5L50 252.5ZM50 182.5L50 177.5L450 177.5L450 182.5L50 182.5Z',
          'alignB': 'M50 450L50 445L450 445L450 450L50 450ZM50 380L50 375L450 375L450 380L50 380ZM50 310L50 305L450 305L450 310L50 310Z',

          'border': 'M240 450L240 440L320 440L320 450L240 450ZM60 60L60 450L50 450L50 50L450 50L450 60L60 60ZM110 450L110 440L190 440L190 450L110 450ZM370 450L370 440L440 440L440 368.1L450 368.1L450 450L370 450ZM440 320L440 240L450 240L450 320L440 320ZM440 190L440 110L450 110L450 190L440 190Z',
          'overflow': 'M405 100L400 100L400 55L55 55L55 400L100 400L100 405L50 405L50 50L405 50L405 100ZM150 355L150 350L450 350L450 355L150 355ZM150 260L150 255L450 255L450 260L150 260ZM150 165L150 160L450 160L450 165L150 165Z',
          'copy': 'M50 107.14L392.86 107.14L392.86 450L50 450L50 107.14Z M450 392.86L450 50L107.14 50 M50 107.14L392.86 107.14L392.86 450L50 450L50 107.14Z',
        },
      },

      mouseData: {
        'mouseDown': false,
        'mouseMove': false,

        'offsetScrollTop': 0,
        'offsetScrollLeft': 0,
        'offsetX': 0,
        'offsetY': 0,
        'posX': 0,
        'posY': 0,
      },

      editorData: {
        'width': 10,
        'height': 10,
        'posX': 0,
        'posY': 0,

        'pagePosX': 0,
        'pagePosY': 0,

        'value' : '',
        
        'tableKey': '',
        'tableCellKeys': [],
        'tableRow' : 1,
        'tableCol' : 1,
        'tableSeq' : 1,
        'tableBorder': false,
        'tableTrigger': false,
        'tableTriggerText': '',

        'show': false,
        'editorResize': false,
        'editorResizeShow': false,
        'editorTextShow': false,
        'editorTableShow': false,

        'editorPageShow': true,
        'pageTrigger': false,
        'pageTriggerText': '',

        'pageSel': '',
        'fieldSel': '',
        'fieldSelDOM': null,
      },
    }
  },
  async mounted() {    // console.log(this.pagerData['pages']['length'])
    await this.loadData();
    if (this.mode == 'P') { this.quickLoad(); }

    // var drawer = document.getElementsByClassName('left-drawer');
    // if (drawer['length'] > 0) {
    //   console.log('%cDrawer Found', 'color: red; font-weight: bold;', drawer[0]);
    //   drawer[0].remove();
    // }
  },
  beforeDestroy() {
    
  },
  methods: {
    //---- Main Methods
    loadData: async function() {
      //---- Set variables
      var pagerDOM = this.$refs['pagerContent'];

      //---- Get scaling ratio
      this.$set(this.pageData, 'whratio', (this.pageData['heightpx'] / this.pageData['widthpx']));
      this.$set(this.pageData, 'ratio', ((pagerDOM.getBoundingClientRect()['width'] * 0.8) / this.pageData['widthpx']));
      this.$set(this.pageData, 'ratioInv', (1 / parseFloat(this.pageData['ratio'])));

      //---- Set Paper size
      this.$set(this.pageData, 'width', this.pageData['widthpx'] * this.toolbarData['zoomLevel']);
      this.$set(this.pageData, 'height', this.pageData['heightpx'] * this.toolbarData['zoomLevel']);

      //---- Adjust zoom level for appropriate viewing
      this.$set(this.toolbarData, 'zoomLevel', parseFloat(this.pageData['ratio'].toFixed(1)));
      this.$set(this.toolbarData, 'zoomLevelInv', parseFloat(1 / this.toolbarData['zoomLevel']));
      this.$set(this.toolbarData, 'zoomLevelInit', parseFloat(this.pageData['ratio'].toFixed(1)));

      //---- Set listeners
      window.addEventListener('keydown', (e) => { this.winKeyDown(e) });
      window.addEventListener('mousewheel', (e) => { this.winMouseWheel(e) });

      //---- Load form images
      // this.loadImg();

      //---- Get Test Keys (ROT submission items)
      var request = await this.$apiCallV2('/ROT/GetROTDetails?cmrno=BFI2103057-06&jobno=');
      if (Array.isArray(request['data'])) { console.log('Rot DATA error'); }
      else if (typeof request['data'] == 'object') { this.$set(this.mainData, 'data', request['data']['ROTDetails']['CMRForm']); }

      Object.keys(this.mainData['data']).forEach((k) => {
        if (Array.isArray(this.mainData['data'][k])) {
          this.mainData['lists'].push({ 'desc': k, 'value': k });
        } else {
          this.mainData['keys'].push({ 'desc': k, 'value': k });
        }
      });

      //---- Generate Test table data for overflow test
      this.mainData['lists'].push({ 'desc': 'Test Data', 'value': 'testdata' });
      var testObj = [];
      for(var t = 0; t < 100; t++) {
        testObj.push({ 'name': ('John Doe' + t), 'age': Math.floor(Math.random() * 100), 'Occupation': 'Test' });
      }
      this.$set(this.mainData['data'], 'testdata', testObj);
      
      //---- Get form images and jsons
      try { // Images
        var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTimage', null);
        if (Array.isArray(request['data'])) { this.$set(this.toolbarData, 'forms', request['data']); }
      } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request['data']); };
      try { // JSONs
        var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTform', null);
        if (Array.isArray(request['data'])) { this.$set(this.toolbarData, 'jsons', request['data']); }
      } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request['data']); };

      //---- Load indicator
      setTimeout(() => { this.$set(this.mainData, 'pageLoaded', true); }, 500); 

    },
    loadImg: async function() {
      //---- Set variables
      var viewerDOM = this.$refs['pageViewer'];

      this.pagerData['pages'].forEach(async (p) => {
        var pageDOM = Array.from(viewerDOM['childNodes']).filter((c) => { return c['id'] == p['id'] });
        if (pageDOM['length'] > 0) {
          pageDOM[0]['style']['backgroundImage'] = '';

          //---- Get page image only if selected
          if (p['form']) {
            try{
              var request = await this.$apiCallV2('/ReportDesigner/ReadImage?folderPath=ROTimage&fileName=' + p['form'], null);
              this.$nextTick((e) => { pageDOM[0]['style']['backgroundImage'] = 'url(\'data:image/png;base64,' + request['data'] + '\')'; });
            } catch(e) { console.log(e); }
          }

        }
      });
    },

    //----Keyboard Methods
    winKeyDown: async function(e) {
      switch(e['code']) {
        case 'Delete':
          if (this.editorData['fieldSel']) {
            //---- Set variables
            var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
            if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
            var fieldObj = pageObj['fields'].filter((f) => { return f['id'] == this.editorData['fieldSel']; });
            if (fieldObj['length'] > 0) { fieldObj = fieldObj[0]; }

            //---- Delete selected field
            var fieldIndex = pageObj['fields'].indexOf(fieldObj);
            pageObj['fields'].splice(fieldIndex, 1);

            //---- Reset field selection
            this.$set(this.editorData, 'fieldSel', '');
            this.$set(this.editorData, 'fieldSelDOM', null);

            //---- Reset toolbar
            this.toolbarReset();

            //---- Reset editor
            this.editorReset();
          }
          break;
      }
    },
    winMouseWheel: async function(e) {
      // if (e['shiftKey'] && this.pagerData['mouseOver']) {
      //   if (e['deltaY'] > 0) {
      //     this.toolbarBtn('zoomSub');
      //   } else {
      //     this.toolbarBtn('zoomAdd');
      //   }
      // }
    },

    //---- Pager Methods
    pagerMouseMove: async function(e) {
      if (this.mouseData['mouseDown']) {
        //---- Set variables
        if (this.editorData['fieldSel']) {
          var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
          if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
          var fieldObj = pageObj['fields'].filter((f) => { return f['id'] == this.editorData['fieldSel']; });
          if (fieldObj['length'] > 0) { fieldObj = fieldObj[0]; }
          var pageDOM = this.$refs[pageObj['id']][0];
        }

        var pagerDOM = this.$refs['pagerContent'];
        
        this.$set(this.mouseData, 'mouseMove', true);

        //---- This happens when moving field, where an editor item is not clicked or dragged (ONLY THE FIELD)
        if (this.editorData['fieldSel'] && this.mouseData['mouseMove'] && e['target']['id'] != 'editorMain' && !this.editorData['editorResize']) {
          //---- Move field
          var posX = ((e['clientX'] - pageDOM.getBoundingClientRect()['left']) - this.mouseData['offsetX']);
          var posY = ((e['clientY'] - pageDOM.getBoundingClientRect()['top']) - this.mouseData['offsetY']);
          if ((posX >= 0) && (posX < ((this.pageData['widthpx'] * this.toolbarData['zoomLevel']) - (fieldObj['width'] * this.toolbarData['zoomLevel'])))) { this.$set(fieldObj, 'posX', (posX * this.toolbarData['zoomLevelInv'])); }
          if ((posY >= 0) && (posY < ((this.pageData['heightpx'] * this.toolbarData['zoomLevel']) - (fieldObj['height'] * this.toolbarData['zoomLevel'])))) { this.$set(fieldObj, 'posY', (posY * this.toolbarData['zoomLevelInv'])); }

          //---- Make editor disappear temporarily
          this.$set(this.editorData, 'show', false);  


        //---- This happens when the resizer item is being dragged
        } else if (this.editorData['fieldSel'] && this.editorData['editorResize']) {
          //---- Set Editor (Resizing)
          this.$set(this.editorData, 'width', ((e['clientX'] - pagerDOM.getBoundingClientRect()['left']) + this.mouseData['offsetScrollLeft']) - this.editorData['posX']);
          this.$set(this.editorData, 'height', ((e['clientY'] - pagerDOM.getBoundingClientRect()['top']) + this.mouseData['offsetScrollTop']) - this.editorData['posY']);

          //---- Resize Field
          this.$set(fieldObj, 'width', ((this.editorData['width'] < 10) ? 10 : this.editorData['width']) * this.toolbarData['zoomLevelInv']);
          this.$set(fieldObj, 'height', ((this.editorData['height'] < 10) ? 10 : this.editorData['height']) * this.toolbarData['zoomLevelInv']);

          //---- Make editor items disappear temporarily
          this.$set(this.editorData, 'editorTextShow', false); 
          this.$set(this.editorData, 'editorTableShow', false); 

          
        //---- This happens when no field is clicked or selected, resizes the editor for selection or creation of field
        } else if (!this.editorData['fieldSel']) {
          //---- Set Editor (Resizing)
          this.$set(this.editorData, 'width', ((e['clientX'] - pagerDOM.getBoundingClientRect()['left']) + this.mouseData['offsetScrollLeft']) - this.mouseData['posX']);
          this.$set(this.editorData, 'height', ((e['clientY'] - pagerDOM.getBoundingClientRect()['top']) + this.mouseData['offsetScrollTop']) - this.mouseData['posY']);

        //---- This happens to prevent movement of field if an editor item was dragged (Text editor items for example)
        } else {
          this.$set(this.mouseData, 'mouseDown', false);
        }
      }

    },
    pagerMouseUp: async function(e) {
      this.$set(this.mouseData, 'mouseDown', false);
      this.$set(this.mouseData, 'mouseMove', false);

      if (this.editorData['pageSel'] && !this.mainData['showData']) {
        // console.log('%cPage Selection', 'color: purple;', this.editorData['pageSel']);
        if (e['shiftKey'] && !this.editorData['fieldSel']) { this.fieldNew(e); }
      }
      // this.$set(this.editorData, 'pageSel', '');

      //---- Reset Editor
      if (!this.editorData['fieldSel']) {
        this.editorReset();
      } else {
        this.editorUpdate();
        this.$set(this.editorData, 'editorResize', false);
      }

    },
    pagerMouseDown: async function(e) {
      this.$set(this.mouseData, 'mouseDown', true);

      //---- Set variables
      var pagerDOM = this.$refs['pagerContent'];

      //---- Check if field was clicked, deselect field if none was clicked
      if (e['target']['id'].search('field') < 0 && e['target']['id'] != 'editorMain') {
        this.$set(this.editorData, 'fieldSel', '');
        this.$set(this.editorData, 'fieldSelDOM', null);
        this.toolbarReset();

        //---- Reset Editor
        this.editorReset();
      }

      //---- Get Mouse click position
      this.$set(this.mouseData, 'posX', (e['clientX'] - pagerDOM.getBoundingClientRect()['left']) + this.mouseData['offsetScrollLeft']);
      this.$set(this.mouseData, 'posY', (e['clientY'] - pagerDOM.getBoundingClientRect()['top']) + this.mouseData['offsetScrollTop']);

      if (this.editorData['fieldSel']) {

      } else {
        //---- Set Editor
        this.$set(this.editorData, 'show', true);
        this.$set(this.editorData, 'posX', (e['clientX'] - pagerDOM.getBoundingClientRect()['left']) + this.mouseData['offsetScrollLeft']);
        this.$set(this.editorData, 'posY', (e['clientY'] - pagerDOM.getBoundingClientRect()['top']) + this.mouseData['offsetScrollTop']);
      }

    },
    pagerMouseOver: async function(e) {
      this.$set(this.pagerData, 'mouseOver', true);
    },
    pagerMouseLeave: async function(e, page) {
      this.$set(this.mouseData, 'mouseDown', false);
      this.$set(this.mouseData, 'mouseMove', false);
      this.$set(this.pagerData, 'mouseOver', false);
    },
    pagerScroll: async function(e) {
      //---- Set variables
      var pagerDOM = this.$refs['pagerContent'];
      this.$set(this.mouseData, 'offsetScrollTop', pagerDOM['scrollTop']);
      this.$set(this.mouseData, 'offsetScrollLeft', pagerDOM['scrollLeft']);

      //---- Update Page editor
      if (this.editorData['pageSel']) { this.$nextTick(() => { this.pageEditorUpdate(); }); }
    },

    //---- Page Methods
    pageMouseUp: async function(e, page) {
      // this.$set(this.editorData, 'pageSel', '');
    },
    pageMouseOver: async function(e, page) {
      if (!this.editorData['fieldSel'] && (this.editorData['pageSel'] != page)) {
        this.$set(this.editorData, 'pageSel', page);
        this.pageEditorUpdate();
      }
    },
    pageMouseLeave: async function(e, page) {
      if (this.mouseData['mouseDown']) {
        this.pagerMouseUp(e);
      }
    },

    //---- Field Methods
    fieldNew: async function(e) {
      //---- Set variables
      var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
      if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
      var viewerDOM = this.$refs['pageViewer'];
      var pageDOM = Array.from(viewerDOM['childNodes']).filter((c) => { return c['id'] == this.editorData['pageSel'] });
      if (pageDOM['length'] > 0) { pageDOM = pageDOM[0]; }

      //---- Reset Field before inserting new Field
      this.toolbarReset();
      
      //---- Get new Field ID
      var fieldID = [];
      pageObj['fields'].forEach((f) => { fieldID.push(parseInt(f['id'].replace(/field/g, ''))); });
      
      var fieldObj = {
        'id': 'field' + (fieldID['length'] > 0 ? (Math.max.apply(null, fieldID) + 1) : 0),
        'width': (this.editorData['width'] < 10 ? 10 : this.editorData['width']) * this.toolbarData['zoomLevelInv'],
        'height': (this.editorData['height'] < 10 ? 10 : this.editorData['height']) * this.toolbarData['zoomLevelInv'],
        'posX': (this.editorData['posX'] - (pageDOM.getBoundingClientRect()['left'] - pageDOM['parentNode']['parentNode'].getBoundingClientRect()['left']) - this.mouseData['offsetScrollLeft']) * this.toolbarData['zoomLevelInv'],
        'posY': (this.editorData['posY'] - (pageDOM.getBoundingClientRect()['top'] - pageDOM['parentNode']['parentNode'].getBoundingClientRect()['top'] + this.mouseData['offsetScrollTop'])) * this.toolbarData['zoomLevelInv'],
        'properties': {
          'type': this.toolbarData['type'], 
          'textFamily': this.toolbarData['textFamily'],
          'textSize':  this.toolbarData['textSize'],
          'textWeight': this.toolbarData['textWeight'],
          'textColor': this.toolbarData['textColor'],
          'textJustify': this.toolbarData['textJustify'],
          'textAlign': this.toolbarData['textAlign'],  

          'value': '',

          'tableKey': '',
          'tableRow': 1,
          'tableCol': 1,
          'tableSeq': 1,
          'tableBorder': false,
          'tableTrigger': false,
          'tableTriggerText': '',
        },
      }

      //---- Insert into page's fields
      pageObj['fields'].push(fieldObj);

      //---- Select New Field
      this.$nextTick(() => {
        this.$set(this.editorData, 'fieldSel', fieldObj['id']);

        //---- Update toolbar with selected Field
        this.toolbarUpdate();

        //---- Set editor to field's position with data filled, function reset's data first.
        this.editorReset();
        this.editorUpdate(); 
      });
    },
    fieldDuplicate: async function(e, field) {
      //---- Set variables
      var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
      if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
      var fieldObj = pageObj['fields'].filter((f) => { return f['id'] == this.editorData['fieldSel']; });
      if (fieldObj['length'] > 0) { fieldObj = fieldObj[0]; }

      //---- Get new Field ID
      var fieldID = [];
      pageObj['fields'].forEach((f) => { fieldID.push(parseInt(f['id'].replace(/field/g, ''))); });

      //---- Copy Field and assign new ID
      var fieldObjDupe = JSON.parse(JSON.stringify(fieldObj));
      this.$set(fieldObjDupe, 'id', 'field' + (fieldID['length'] > 0 ? (Math.max.apply(null, fieldID) + 1) : 0));
      this.$set(fieldObjDupe, 'posX', fieldObjDupe['posX'] + 10);
      this.$set(fieldObjDupe, 'posY', fieldObjDupe['posY'] + 10);

      switch(fieldObjDupe['properties']['type']) {
        case 'table':
          this.$set(fieldObjDupe['properties'], 'tableSeq', (parseInt(fieldObjDupe['properties']['tableSeq']) + parseInt(fieldObjDupe['properties']['tableRow'])).toString());
          break;
      }

      //---- Insert into page's fields
      pageObj['fields'].push(fieldObjDupe);

      //---- Select New Field
      this.$nextTick(() => {
        this.$set(this.editorData, 'fieldSel', fieldObjDupe['id']);

        //---- Update toolbar with selected Field
        this.toolbarUpdate();

        //---- Set editor to field's position with data filled, function reset's data first.
        this.editorReset();
        this.editorUpdate(); 
      });
    },
    fieldUpdate: async function() {
      //---- Set variables
      var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
      if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
      var fieldObj = pageObj['fields'].filter((f) => { return f['id'] == this.editorData['fieldSel']; });
      if (fieldObj['length'] > 0) { fieldObj = fieldObj[0]; }

      if (this.editorData['fieldSel']) {
        this.$set(fieldObj['properties'], 'type', this.toolbarData['type']);
        this.$set(fieldObj['properties'], 'textFamily', this.toolbarData['textFamily']);
        this.$set(fieldObj['properties'], 'textSize', this.toolbarData['textSize']);
        this.$set(fieldObj['properties'], 'textWeight', this.toolbarData['textWeight']);
        this.$set(fieldObj['properties'], 'textColor', this.toolbarData['textColor']);
        this.$set(fieldObj['properties'], 'textJustify', this.toolbarData['textJustify']);
        this.$set(fieldObj['properties'], 'textAlign', this.toolbarData['textAlign']);
      }

      //---- Enable appropriate editor tools
      this.$set(this.editorData, 'editorTextShow', (fieldObj['properties']['type'] == 'text'));
      this.$set(this.editorData, 'editorTableShow', (fieldObj['properties']['type'] == 'table'));
    },
    fieldMouseDown: async function(e, field) {
      if (!this.mainData['showData']) {
        this.$set(this.editorData, 'fieldSel', field);
        this.$set(this.editorData, 'fieldSelDOM', e['target']);
        // console.log(this.editorData['fieldSel']);
        this.$set(this.mouseData, 'offsetX', e['layerX']);
        this.$set(this.mouseData, 'offsetY', e['layerY']);

        //---- Update toolbar with selected Field
        this.toolbarUpdate();

        //---- Set editor to field's position with data filled, function reset's data first.
        this.editorReset();
        this.editorUpdate(); 
      }
    },


    //---- Toolbar Methods
    toolbarBtn: async function(btn, cmd) {
      switch(btn) {
        case 'justify':
          this.$set(this.toolbarData, 'textJustify', cmd);
          break;
        case 'align':
          this.$set(this.toolbarData, 'textAlign', cmd);
          break;
        case 'bold':
          this.$set(this.toolbarData, 'textWeight', this.toolbarData['textWeight'] == 'bold' ? 'normal' : 'bold');
          break;
        case 'loadImg':
          //---- Set variables
          var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == 'page0'; });
          if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
          var imgSelectDOM = this.$refs['pagerFormSelect'];

          this.$set(pageObj, 'form', imgSelectDOM['value']);
          // console.log(imgSelectDOM['value']);
          this.$nextTick(() => { this.loadImg(); });
          break;
        case 'loadJson':
          //---- Set variables
          var jsonSelectDOM = this.$refs['pagerJsonSelect'];
          var request = await this.$apiCallV2('/ReportDesigner/ReadFiles?folderPath=ROTform&fileName=' + jsonSelectDOM['value'], null);
          if (Array.isArray(request['data']['data'])) {
            this.$set(this.pagerData, 'pages', request['data']['data']);
            this.$nextTick(() => { this.loadImg(); });

            //---- Set save name field (TEMPORARY USAGE)
            this.$set(this.mainData, 'saveName', jsonSelectDOM['value'].split('\.')[0]);
          }
          console.log(request)
          this.editorReset();

          //---- Reset selected items
          this.$set(this.editorData, 'fieldSel', '');
          this.$set(this.editorData, 'fieldSelDOM', null);

          break;
        case 'zoomReset':
          this.$set(this.toolbarData, 'zoomLevel', this.toolbarData['zoomLevelInit']);
          this.$set(this.toolbarData, 'zoomLevelInv', parseFloat(1 / this.toolbarData['zoomLevel']));
          if (this.editorData['fieldSel']) { this.$nextTick(() => { this.editorUpdate(); }); }
          if (this.editorData['pageSel']) { this.$nextTick(() => { this.pageEditorUpdate(); }); }
          break;
        case 'zoomAdd':
          this.$set(this.toolbarData, 'zoomLevel', (parseFloat(this.toolbarData['zoomLevel'].toFixed(1)) < 2) ? (this.toolbarData['zoomLevel'] + 0.1) : this.toolbarData['zoomLevel']);
          this.$set(this.toolbarData, 'zoomLevelInv', parseFloat(1 / this.toolbarData['zoomLevel']));
          if (this.editorData['fieldSel']) { this.$nextTick(() => { this.editorUpdate(); }); }
          if (this.editorData['pageSel']) { this.$nextTick(() => { this.pageEditorUpdate(); }); }
          break;
        case 'zoomSub':
          this.$set(this.toolbarData, 'zoomLevel', (parseFloat(this.toolbarData['zoomLevel'].toFixed(1)) > 0.2) ? (this.toolbarData['zoomLevel'] - 0.1) : this.toolbarData['zoomLevel']);
          this.$set(this.toolbarData, 'zoomLevelInv', parseFloat(1 / this.toolbarData['zoomLevel']));
          if (this.editorData['fieldSel']) { this.$nextTick(() => { this.editorUpdate(); }); }
          if (this.editorData['pageSel']) { this.$nextTick(() => { this.pageEditorUpdate(); }); }
          break;
        case 'explorer':
          this.$set(this.mainData, 'explorerShow', true);
          this.$set(this.mainData, 'explorerPage', cmd);
          break;
        case 'saveSave':
          this.$set(this.mainData, 'saveShow', true);

          //---- Refresh JSON list
          try {
            var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTform', null);
            if (Array.isArray(request['data'])) { this.$set(this.toolbarData, 'jsons', request['data']); }
          } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request['data']); };

          this.toolbarBtn('saveList');
          break;
        case 'saveList':
          var itemsFound = this.toolbarData['jsons'].filter((j) => { return ((j['file'].split('\.')[0]).search(this.mainData['saveName']) >= 0); });
          this.$set(this.mainData, 'saveList', itemsFound);
          break;
        case 'saveConfirm':
          try {
            var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=form&folderPath=ROTform&fileName=' + ((this.mainData['saveName'] ? this.mainData['saveName'] : 'DefaultJSON') + '.json'), { 'JSON': this.pagerData['pages'] });
            console.log('%cRequest Success', 'color: #00ff00;', request['data']);
          } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', e); };

          //---- Refresh JSON list
          try {
            var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTform', null);
            if (Array.isArray(request['data'])) { this.$set(this.toolbarData, 'jsons', request['data']); }
          } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request['data']); };

          this.$set(this.mainData, 'saveShow', false);

          //---- Set Save names for future use
          this.$set(this.mainData, 'saveNameOriginal', this.mainData['saveName']);
          break;
        case 'saveCancel':
          this.$set(this.mainData, 'saveShow', false);

          //---- Reset input to original/initial name
          this.$set(this.mainData, 'saveName', this.mainData['saveNameOriginal']);
          break;
        case 'print':
          
          //---- Set variables
          var toolbarZoom = this.toolbarData['zoomLevel'];
          var showData = this.mainData['showData'];
          var pagerData = JSON.parse(JSON.stringify(this.pagerData['pages']));
          
          //---- Reset editor disappear before print
          this.editorReset();

          //---- Reset zoom level temporarily
          this.$set(this.toolbarData, 'zoomLevel', 1);

          //---- Reset other data to reduce chance of paper overflow
          this.$set(this.mouseData, 'posX', 0);
          this.$set(this.mouseData, 'posY', 0);
          
          //---- Show data available before printing (Don't print Fields)
          this.$set(this.mainData, 'showData', true);

          //---- Generate extra pages for auto generate feature on Table fields
          if (this.mode != 'P') { this.pageAutoGenerate(); }

          setTimeout(() => {
            //---- Set variables
            var printData = this.$refs['pageViewer'].innerHTML;

            //---- Get CSS / Print Page CSS (Can configure)
            var list = document.documentElement.getElementsByTagName('style');
            var css = '';
            for (let c of list) { css += c.outerHTML; }
            css += '<style>'
            css += '@page { size: A4 portrait; padding: 0px; margin: 0px; }';
            css += '* { -webkit-print-color-adjust: exact; box-sizing: border-box; }';
            css += 'body { margin: 0px; }';
            css += '</style>';

            //---- Page Setup
            var mywindow = window.open('_blank', 'PRINT');
            mywindow.document.write(`<html><head><title>Report Designer</title>` + css);
            mywindow.document.write('</head><body style="margin: 0px; position: absolute;">');
            mywindow.document.write(printData);
            mywindow.document.write('</body></html>');

            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/

            mywindow.print();
            mywindow.close();

            //---- Refresh images (some error when after printing, images disappear)
            this.$nextTick((e) => { this.loadImg(); });

            //---- Reset zoom level
            this.$set(this.toolbarData, 'zoomLevel', parseFloat(toolbarZoom.toFixed(1)));

            //---- Reset pages (prior to auto generate)
            this.$set(this.pagerData, 'pages', pagerData);

            //---- Reset Show data
            this.$set(this.mainData, 'showData', showData);
          }, 1);
          break;
        case 'cancel':
          //---- Quick print cancel event
          this.$emit('quickPrintCancel');
          break;
        case 'reset':
          //---- Set variables
          var formDropdown = this.$refs['pagerFormSelect'];

          //---- Reset Dropdowns
          formDropdown['value'] = '';

          //---- Reset editor etc
          this.$set(this.editorData, 'pageSel', '');
          this.$set(this.editorData, 'fieldSel', '');
          this.$set(this.editorData, 'fieldSelDOM', null);

          this.editorReset();
          this.toolbarReset();

          //---- Reset Pager
          this.$set(this.pagerData, 'pages', [{ 'id': 'page0', 'form': '', 'fields': [] }]);
          this.loadImg();

          //---- Reset Save Names
          this.$set(this.mainData, 'saveName', '');
          this.$set(this.mainData, 'saveNameOriginal', '');

          break;
        default: 
          break;
      }

      //---- Update field data
      if (this.editorData['fieldSel']) { this.fieldUpdate(); }
    },
    toolbarUpdate: async function() {
      //---- Set variables
      var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
      if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
      var fieldObj = pageObj['fields'].filter((f) => { return f['id'] == this.editorData['fieldSel']; });
      if (fieldObj['length'] > 0) { fieldObj = fieldObj[0]; }

      this.$set(this.toolbarData, 'type', fieldObj['properties']['type']);
      this.$set(this.toolbarData, 'textFamily', fieldObj['properties']['textFamily']);
      this.$set(this.toolbarData, 'textSize', fieldObj['properties']['textSize']);
      this.$set(this.toolbarData, 'textWeight', fieldObj['properties']['textWeight']);
      this.$set(this.toolbarData, 'textColor', fieldObj['properties']['textColor']);
      this.$set(this.toolbarData, 'textJustify', fieldObj['properties']['textJustify']);
      this.$set(this.toolbarData, 'textAlign', fieldObj['properties']['textAlign']);
    },
    toolbarReset: async function() {
      this.$set(this.toolbarData, 'type', 'text');
      this.$set(this.toolbarData, 'textFamily', 'Arial');
      this.$set(this.toolbarData, 'textSize', 12);
      this.$set(this.toolbarData, 'textWeight', 'normal');
      this.$set(this.toolbarData, 'textColor', '#000000');
      this.$set(this.toolbarData, 'textJustify', 'left');
      this.$set(this.toolbarData, 'textAlign', 'top');
    },

    //---- Editor Methods
    editorBtn: async function(btn) {
      //---- Set variables
      var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
      if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
      var fieldObj = pageObj['fields'].filter((f) => { return f['id'] == this.editorData['fieldSel']; });
      if (fieldObj['length'] > 0) { fieldObj = fieldObj[0]; }
      var textareaDOM = this.$refs['editorTextarea'];
      var textselectDOM = this.$refs['editorTextselect'];
      var tableselectkeyDOM = this.$refs['editorTablekeyselect'];

      switch(btn) {
        case 'textarea':
          //---- Update field's value
          this.$set(fieldObj['properties'], 'value', this.editorData['value']);

          break;
        case 'textselect':
          var caret = textareaDOM['selectionStart'] + (textselectDOM['value']['length'] + 2);
          var leftText = this.editorData['value'].slice(0, textareaDOM['selectionStart']);
          var rightText = this.editorData['value'].slice(textareaDOM['selectionEnd'], this.editorData['value']['length']);

          //---- Update editor textarea with new key
          this.$set(this.editorData, 'value', leftText + '{' + textselectDOM['value'] + '}' + rightText);

          //---- Update field's value
          this.$set(fieldObj['properties'], 'value', this.editorData['value']);

          //---- Reset textarea focus
          textareaDOM.focus();
          this.$nextTick(() => { 
            textareaDOM['selectionStart'] = caret;
            textareaDOM['selectionEnd'] = caret;
          });
          break;
        case 'tablerow':
          if (this.editorData['tableRow'] <= 0) { this.$set(this.editorData, 'tableRow', 1); }
          this.$set(fieldObj['properties'], 'tableRow', this.editorData['tableRow']);
          break;
        case 'tablecol':
          if (this.editorData['tableCol'] <= 0) { this.$set(this.editorData, 'tableCol', 1); }
          this.$set(fieldObj['properties'], 'tableCol', this.editorData['tableCol']);
          this.$nextTick(() => { this.editorBtn('tablekeyselect'); });
          break;
        case 'tableseq':
          if (this.editorData['tableSeq'] <= 0) { this.$set(this.editorData, 'tableSeq', 1); }
          this.$set(fieldObj['properties'], 'tableSeq', this.editorData['tableSeq']);
          break;
        case 'tableselect':
          this.$set(fieldObj['properties'], 'tableKey', this.editorData['tableKey']);
          if (this.mainData['data'][this.editorData['tableKey']] && this.mainData['data'][this.editorData['tableKey']]['length'] > 0) {
            this.$set(this.editorData, 'tableCellKeys', []);
            Object.keys(this.mainData['data'][this.editorData['tableKey']][0]).forEach((k) => {
              this.editorData['tableCellKeys'].push({ 'desc': k, 'value': k });
            });
          }
          break;
        case 'tablekeyselect':
          if (tableselectkeyDOM && tableselectkeyDOM['length'] > 0) {
            var cellData = '';
            tableselectkeyDOM.forEach((k) => {
              var cellObj = {
                'key': k['value'],
              }
              cellData = cellData + JSON.stringify(cellObj);
            });
            this.$set(fieldObj['properties'], 'value', cellData);
            console.log(fieldObj['properties']['value']);
          }
          break;
        case 'tableborder': 
          this.$set(this.editorData, 'tableBorder', !this.editorData['tableBorder']);
          this.$set(fieldObj['properties'], 'tableBorder', this.editorData['tableBorder']);
          break;
        case 'resizeMouseDown':
          this.$set(this.editorData, 'editorResize', true);
          break;
        case 'tabletrigger': 
          this.$set(this.editorData, 'tableTrigger', !this.editorData['tableTrigger']);
          this.$set(fieldObj['properties'], 'tableTrigger', this.editorData['tableTrigger']);
          break;
        case 'tabletriggertext': 
          // this.$set(fieldObj['properties'], 'tableTriggerText', this.editorData['tableTriggerText']);

          //---- Get all tables with similar table Key
          var tables = {};
          this.pagerData['pages'].forEach((p) => {
            var tableTemp = p['fields'].filter((f) => { return f['properties']['tableTrigger'] && (f['properties']['tableKey'] == fieldObj['properties']['tableKey']); });
            tableTemp.forEach((t) => {
              if (tables[t['properties']['tableKey']]) {
                tables[t['properties']['tableKey']].push(t);
              } else {
                this.$set(tables, t['properties']['tableKey'], []);
                tables[t['properties']['tableKey']].push(t);
              }
            });
          });

          //---- Update ALL tables with same trigger
          tables[fieldObj['properties']['tableKey']].forEach((t) => {
            this.$set(t['properties'], 'tableTriggerText', this.editorData['tableTriggerText']);
          });

          break;
      }
    },
    editorUpdate: async function() {
      //---- Set variables
      var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
      if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
      var fieldObj = pageObj['fields'].filter((f) => { return f['id'] == this.editorData['fieldSel']; });
      if (fieldObj['length'] > 0) { fieldObj = fieldObj[0]; }

      this.$nextTick(() => {
        var pagerDOM = this.$refs['pagerContent'];
        var pageDOM = this.$refs[pageObj['id']][0];
        
        if (this.editorData['fieldSel']) {
          //---- Set Editor
          this.$set(this.editorData, 'posX', ((fieldObj['posX'] * this.toolbarData['zoomLevel']) + (pageDOM.getBoundingClientRect()['left'] - pagerDOM.getBoundingClientRect()['left'])) + this.mouseData['offsetScrollLeft']);
          this.$set(this.editorData, 'posY', ((fieldObj['posY'] * this.toolbarData['zoomLevel']) + (pageDOM.getBoundingClientRect()['top'] - pagerDOM.getBoundingClientRect()['top'])) + this.mouseData['offsetScrollTop']);

          this.$set(this.editorData, 'width', (fieldObj['width'] * this.toolbarData['zoomLevel']));
          this.$set(this.editorData, 'height', (fieldObj['height'] * this.toolbarData['zoomLevel']));

          //---- Enable appropriate editor tools
          this.$set(this.editorData, 'show', true);
          this.$set(this.editorData, 'editorResizeShow', true);
          this.$set(this.editorData, 'editorTextShow', (fieldObj['properties']['type'] == 'text'));
          this.$set(this.editorData, 'editorTableShow', (fieldObj['properties']['type'] == 'table'));

          //---- Update editor with field's data
          this.$set(this.editorData, 'tableKey', fieldObj['properties']['tableKey']);
          this.$set(this.editorData, 'tableRow', fieldObj['properties']['tableRow']);
          this.$set(this.editorData, 'tableCol', fieldObj['properties']['tableCol']);
          this.$set(this.editorData, 'tableSeq', fieldObj['properties']['tableSeq']);
          this.$set(this.editorData, 'tableBorder', fieldObj['properties']['tableBorder']);
          this.$set(this.editorData, 'tableTrigger', fieldObj['properties']['tableTrigger']);
          this.$set(this.editorData, 'tableTriggerText', fieldObj['properties']['tableTriggerText']);

          //---- Get table keys for each cell
          if (this.mainData['data'][this.editorData['tableKey']] && this.mainData['data'][this.editorData['tableKey']]['length'] > 0) {
            this.$set(this.editorData, 'tableCellKeys', []);
            Object.keys(this.mainData['data'][this.editorData['tableKey']][0]).forEach((k) => {
              this.editorData['tableCellKeys'].push({ 'desc': k, 'value': k });
            });
          }

          //---- Update field value
          // console.log('%cEditor Update', 'color: purple', fieldObj['properties']['type']);
          switch(fieldObj['properties']['type']) {
            case 'text':
              this.$set(this.editorData, 'value', fieldObj['properties']['value']);
              break;
            case 'table':
              // console.log(fieldObj['properties']['value']);
              //---- Set variables
              var text = JSON.parse(JSON.stringify(fieldObj['properties']['value']));
              var match = [];
              var pattern = /{([^}]*)}/g;

              this.$nextTick(() => {
                //---- Get keys found in text and fill cell selectors
                var textKeys = [];
                while (match = pattern.exec(text)) { textKeys.push(match[0]); }
                // console.log(textKeys);
                
                if (textKeys['length'] > 0) {
                  var tableselectkeyDOM = this.$refs['editorTablekeyselect'];
                  textKeys.forEach((k, i) => {
                    var cellObj = JSON.parse(k);
                    tableselectkeyDOM[i]['value'] = cellObj['key'] ? cellObj['key'] : '';
                  });
                }
              });
              break;
          }
        }
      });

    },
    editorReset: async function() {
      this.$set(this.editorData, 'width', 10);
      this.$set(this.editorData, 'height', 10);
      this.$set(this.editorData, 'posX', 0);
      this.$set(this.editorData, 'posY', 0);
      this.$set(this.editorData, 'show', false);
      this.$set(this.editorData, 'editorResize', false);
      this.$set(this.editorData, 'editorResizeShow', false);
      this.$set(this.editorData, 'editorTextShow', false);
      this.$set(this.editorData, 'editorTableShow', false);

      this.$set(this.editorData, 'value', '');
      this.$set(this.editorData, 'tableKey', '');
      this.$set(this.editorData, 'tableCellKeys', '');
      this.$set(this.editorData, 'tableRow', 1);
      this.$set(this.editorData, 'tableCol', 1);
      this.$set(this.editorData, 'tableSeq', 1);
      this.$set(this.editorData, 'tableBorder', false);
      this.$set(this.editorData, 'tableTrigger', false);
      this.$set(this.editorData, 'tableTriggerText', '');

      // this.$set(this.editorData, 'pageTrigger', false);
      // this.$set(this.editorData, 'pageTriggerText', '');

      // this.$set(this.editorData, 'pageSel', '');
      // this.$set(this.editorData, 'fieldSel', '');
      // this.$set(this.editorData, 'fieldSelDOM', null);
    },
    pageEditorBtn: async function(btn) {
      var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
      if (pageObj['length'] > 0) { pageObj = pageObj[0]; }

      switch(btn) {
        case 'pagetrigger':
          this.$set(this.editorData, 'pageTrigger', !this.editorData['pageTrigger']);
          this.$set(pageObj['properties'], 'pageTrigger', this.editorData['pageTrigger']);
          break;
        case 'pagetriggertext':
          this.$set(pageObj['properties'], 'pageTriggerText', this.editorData['pageTriggerText']);
          break;
      }
    },
    pageEditorUpdate: async function() {
      //---- Set variables
      var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == this.editorData['pageSel']; });
      if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
      var viewerDOM = this.$refs['pageViewer'];
      var pageDOM = Array.from(viewerDOM['childNodes']).filter((c) => { return c['id'] == this.editorData['pageSel'] });
      if (pageDOM['length'] > 0) { pageDOM = pageDOM[0]; }

      this.$set(this.editorData, 'pagePosX', ((pageDOM.getBoundingClientRect()['left'] - pageDOM['parentNode']['parentNode'].getBoundingClientRect()['left']) + this.mouseData['offsetScrollLeft']));
      this.$set(this.editorData, 'pagePosY', ((pageDOM.getBoundingClientRect()['top'] - pageDOM['parentNode']['parentNode'].getBoundingClientRect()['top']) + this.mouseData['offsetScrollTop']));
    
      //---- Update editor with page's properties
      this.$set(this.editorData, 'pageTrigger', pageObj['properties']['pageTrigger']);
      this.$set(this.editorData, 'pageTriggerText', pageObj['properties']['pageTriggerText']);
    },

    //---- Page Detection Methods
    pageAutoGenerate: async function() {
      console.log('%cData Check', 'color: hotpink;');

      //---- Set variables

      //---- Get all tables with Triggers
      var tables = {};
      this.pagerData['pages'].forEach((p) => {
        var tableTemp = p['fields'].filter((f) => { return f['properties']['tableTrigger']; });
        tableTemp.forEach((t) => {
          if (tables[t['properties']['tableKey']]) {
            tables[t['properties']['tableKey']].push(t);
          } else {
            this.$set(tables, t['properties']['tableKey'], []);
            tables[t['properties']['tableKey']].push(t);
          }
        });
      });
      
      //---- Get number of data for each array based key
      // Check main data for overflowing data (more than set)
      var keyLength = {};
      Object.keys(tables).forEach((k) => { this.$set(keyLength, k, this.mainData['data'][k]['length']); });
      // console.log(keyLength);
      
      //---- Get max allocated rows for each table
      var tableGroups = {};
      Object.keys(tables).forEach((k) => {
        tables[k].forEach((t) => {
          // console.log(t);
          // rows += parseInt(t['properties']['tableRow']);
          if (tableGroups[t['properties']['tableKey']]) {
            this.$set(tableGroups[t['properties']['tableKey']], 'rows', tableGroups[t['properties']['tableKey']]['rows'] + parseInt(t['properties']['tableRow']));
          } else {
            this.$set(tableGroups, t['properties']['tableKey'], { 'data': t, 'rows': parseInt(t['properties']['tableRow']) });
          }
        });
      });

      //---- Get Triggers
      var tableTriggers = {};
      var tableNullTriggers = {};
      Object.keys(tableGroups).forEach((r) => {
        if (keyLength[r] > tableGroups[r]['rows']) {
          if (tableGroups[r]['data']['properties']['tableTriggerText'] == '') {
            this.$set(tableNullTriggers, tableGroups[r]['data']['properties']['tableKey'], { 'data': tableGroups[r]['data'], 'repeats': 1, 'rows': tableGroups[r]['rows'] });
          } else {
            this.$set(tableTriggers, tableGroups[r]['data']['properties']['tableTriggerText'], { 'data': tableGroups[r]['data'], 'repeats': 1, 'rows': tableGroups[r]['rows'] });
          }
        }
      });

      //---- Process Null Triggers (Generates fresh page with no reference)
      Object.keys(tableNullTriggers).forEach(async (t) => {
        // var pageObj = this.pagerData['pages'].filter((p) => { return t == p['properties']['pageTriggerText'] });
        // if (pageObj['length'] > 0) { pageObj = pageObj[0]; }

        //---- Set properties of new generated table
        var tableKeys = [];
        var tableCellHeight = tableNullTriggers[t]['data']['height'] / tableNullTriggers[t]['data']['properties']['tableRow'];

        //console.log(tableCellHeight);

        //-- Get keys
        var match = [];
        var pattern = /{([^}]*)}/g;
        while (match = pattern.exec(tableNullTriggers[t]['data']['properties']['value'])) { tableKeys.push(JSON.parse(match[0])); }
        
        //-- Generate pages
        var tableRowGenerated = tableNullTriggers[t]['rows'];

        do {
          //-- Get new Page ID
          var pageID = [];
          this.pagerData['pages'].forEach((p) => { pageID.push(parseInt(p['id'].replace(/page/g, ''))); });
          var newPageID = 'page' + (pageID['length'] > 0 ? (Math.max.apply(null, pageID) + 1) : 0);

          var newPage =  { 
            'id': newPageID,
            'form': '', 
            'properties': {
              'pageTrigger': false,
              'pageTriggerText': '',
            }, 
            'fields': [],
            'version': 1,
          }
          this.pagerData['pages'].push(newPage);

          //-- Get Row Data (that needs to be generated, thus ignores already existing)
          // console.log(parseInt(tableNullTriggers[t]['rows']) + 1);
          // console.log(keyLength[t]);
          // console.log(tableNullTriggers[t]['data']['properties']['tableKey']);

          var newTable = {
            'id': 'field0',
            'width': this.pageData['widthpx'] * 0.9,
            'height': tableCellHeight,
            'posX': this.pageData['widthpx'] * 0.05,
            'posY': 25,
            'properties': {
              'type': 'table',
              'textFamily': 'Arial',
              'textSize': 12,
              'textWeight': 'normal',
              'textColor': '#000000',
              'textJustify': 'left',
              'textAlign': 'top',
              'value': tableNullTriggers[t]['data']['properties']['value'],
              'tableKey': tableNullTriggers[t]['data']['properties']['tableKey'],
              'tableRow': '1',
              'tableCol': tableNullTriggers[t]['data']['properties']['tableCol'],
              'tableSeq': parseInt(tableNullTriggers[t]['rows']) + 1,
              'tableBorder': true,
              'tableTrigger': false,
              'tableTriggerText': '',
            }
          }
          newPage['fields'].push(newTable);

          //-- Insert Rows 1 by 1 and check the height of the table for overflow
          var pageObj = this.pagerData['pages'].filter((p) => { return p['id'] == newPageID; });
          if (pageObj['length'] > 0) { pageObj = pageObj[0]; }
          var fieldObj = pageObj['fields'].filter((f) => { return f['id'] == 'field0'; });
          if (fieldObj['length'] > 0) { fieldObj = fieldObj[0]; }
          var pageDOM = null;
          var fieldDOM = null;

          await this.$nextTick(() => {
            pageDOM = this.$refs[newPageID][0];
            fieldDOM = Array.from(pageDOM['childNodes']).filter((f) => { return f['id'] == 'field0'; });
            if (fieldDOM['length'] > 0) { fieldDOM = fieldDOM[0]; }
          });

          //-- Generate new Tables and stop when no more data to be generated
          var tableRowCount = 0;
          do {
            if ((keyLength[t] - tableRowGenerated) <= 0) { break; } else { tableRowCount += 1; }
            await this.pageOverflowCheck(tableNullTriggers[t]['rows'], tableCellHeight, tableRowCount, pageObj, fieldObj);
            tableRowGenerated += 1;
            this.$set(tableNullTriggers[t], 'rows', tableRowGenerated);
          } while (fieldDOM.getBoundingClientRect()['height'] < (this.pageData['heightpx'] - 50));

        } while (tableRowGenerated < keyLength[t]);
      });
    },
    pageOverflowCheck: async function(rowsStart, rowsHeight, rows, page, field) {
      for (var i = rowsStart; i < (rowsStart + rows); i++) {
        this.$set(field, 'height', rowsHeight * ((i - rowsStart) + 1));
        this.$set(field['properties'], 'tableRow', ((i - rowsStart) + 1));
      }
    },

    //---- Explorer Methods
    explorerFormSelect: async function(file) {
      //---- Set variables
      var request = await this.$apiCallV2('/ReportDesigner/ReadFiles?folderPath=ROTform&fileName=' + file, null);
      if (Array.isArray(request['data']['data'])) {
        this.$set(this.pagerData, 'pages', request['data']['data']);
        this.$nextTick(() => { this.loadImg(); });

        //---- Set save name field (TEMPORARY USAGE)
        this.$set(this.mainData, 'saveName', file.split('\.')[0]);
        this.$set(this.mainData, 'saveNameOriginal', file.split('\.')[0]);
      }
      console.log(request)
      this.editorReset();

      //---- Reset selected items
      this.$set(this.editorData, 'fieldSel', '');
      this.$set(this.editorData, 'fieldSelDOM', null);

    },

    //---- Quick Print Methods
    quickLoad: async function() {
      if (this.data && this.form) {
        var request = await this.$apiCallV2('/ReportDesigner/ReadFiles?folderPath=ROTform&fileName=' + this.form + '.json', null);
        if (Array.isArray(request['data']['data'])) {
          this.$set(this.pagerData, 'pages', request['data']['data']);
          this.$nextTick(() => { this.loadImg(); });

          //---- Set to show data mode (Ready for print)
          this.$set(this.mainData, 'showData', true);
        }

        //---- Set data to data coming from page
        this.$set(this.mainData, 'data', this.data);

        this.pageAutoGenerate();
      }
    },

    //---- Legacy Support
    versionCheck: async function() {
      
    },


    //---- Misc Methods
    testBtn: async function(btn) {
      switch(btn) {
        case 'saveData':
          try {
            var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=form&folderPath=ROTform&fileName=' + ((this.mainData['saveName'] ? this.mainData['saveName'] : 'DefaultJSON') + '.json'), { 'JSON': this.pagerData['pages'] });
            console.log('%cRequest Success', 'color: #00ff00;', request['data']);
          } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', e); };

          //---- Retrieve saved JSONs
          try {
            var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTform', null);
            if (Array.isArray(request['data'])) { this.$set(this.toolbarData, 'jsons', request['data']); }
          } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request['data']); };

          //---- Reset some data
          this.$set(this.mainData, 'saveName', '');
          break;
        case 'getData':
          console.log('%cOutput Data', 'color: lightgreen;', JSON.stringify(this.pagerData['pages']));
          break;
        case 'loadData':
          console.log('%cLoad Data', 'color: yellow;', 'Test Load Data');
          this.$set(this.mainData, 'showData', !this.mainData['showData']);
          this.editorReset();
          this.toolbarReset();
          this.$set(this.editorData, 'fieldSel', '');
          this.$set(this.editorData, 'fieldSelDOM', null);
          break;
        case 'getRatio':
          console.log('%cRatio', 'color: yellow;', this.pageData['ratio']);
          console.log('%cRatio Inverse', 'color: yellow;', this.pageData['ratioInv']);
          console.log('%cWidth px', 'color: yellow;', this.pageData['width']);
          console.log('%cHeight px', 'color: yellow;', this.pageData['height']);
          break;
        case 'print':
          this.editorReset();
          
          //---- Set variables
          var pagerDOM = this.$refs['pageViewer'];
          var editorShow = this.editorData['show'];
          var toolbarZoom = this.toolbarData['zoomLevel'];

          //---- Make editor disappear before print
          this.$set(this.editorData, 'show', false);

          //---- Reset zoom level temporarily
          this.$set(this.toolbarData, 'zoomLevel', 1);

          //---- Reset other data to reduce chance of paper overflow
          this.$set(this.mouseData, 'posX', 0);
          this.$set(this.mouseData, 'posY', 0);

          this.$nextTick((e) => {
            //---- Set variables
            var printData = pagerDOM.innerHTML;
            var oriData = document.body.innerHTML;

            //---- Get CSS / Print Page CSS (Can configure)
            var list = document.documentElement.getElementsByTagName('style');
            var css = '';
            for (let c of list) { css += c.outerHTML; }
            css += '<style>'
            css += '@page { size: A4 portrait; padding: 0px; margin: 0px; }';
            css += '* { -webkit-print-color-adjust: exact; box-sizing: border-box; }';
            css += 'body { margin: 0px; }';
            css += '</style>';

            //---- Page Setup
            // var mywindow = window.open('', 'PRINT', 'height=' + '600' + ',width=' + '800' + ',top=50,left=150');
            var mywindow = window.open('_blank', 'PRINT');
            mywindow.document.write(`<html><head><title>Report Designer</title>` + css);
            mywindow.document.write('</head><body>');
            mywindow.document.write(printData);
            mywindow.document.write('</body></html>');

            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/

            mywindow.print();
            mywindow.close();

            // document.body.innerHTML = printData;
            // this.$nextTick((e) => { 
            //   window.print();
            //   //document.body.innerHTML = oriData;
            // });

            //---- Refresh images (some error when after printing, iamges disappear)
            this.$nextTick((e) => { this.loadImg(); });
            
            //---- Reset editor's show state
            this.$set(this.editorData, 'show', editorShow);

            //---- Reset zoom level
            this.$set(this.toolbarData, 'zoomLevel', parseFloat(toolbarZoom.toFixed(1)));
          });
          break;
        case 'reset':
          //---- Set variables
          var jsonSelectDOM = this.$refs['pagerJsonSelect'];
          var formSelectDOM = this.$refs['pagerFormSelect'];

          this.$set(this.pagerData, 'pages', [{ 'id': 'page0', 'form': '', 'fields': [] }]);
          this.$set(this.mainData, 'saveName', '');
          jsonSelectDOM['value'] = '';
          formSelectDOM['value'] = '';
          this.editorReset();
          this.toolbarReset();
          this.loadImg();
          this.$set(this.toolbarData, 'zoomLevel', 1);
          this.$set(this.toolbarData, 'zoomLevelInv', 1);
          
          break;
      }
    },
  },
  watch: {
    // template: { deep: true, handler(h) { /*code*/ } },
    form: function(val) {
      this.quickLoad();
    },
    data: function(val) {
      this.quickLoad();
    }
  },
};
</script>

<style scoped>
  .pagerMain {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: #ffff;
    overflow: hidden;
  }

  /* -- Controls CSS -- */
  body button {
    width: 26px;
    height: 26px;
    font-size: 12px;
    line-height: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }
  
  body button:hover {
    background-color: #eeef;
  }
  
  body button:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  body button svg {
    width: auto;
    height: auto;
    position: absolute;
    top: 1px;
    bottom: 1px;
    left: 1px;
    right: 1px;
    fill: #0000;
    stroke: #000f;
    stroke-width: 12px;
    pointer-events: none;
  }

  body button.selected {
    background-color: #99ceff;
  }

  body input {
    width: 100%;
    height: 26px;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body input:hover {
    border: solid 1px #0004;
  }
  
  body input:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  body input:disabled {
    background-color: #dddf;
  }
  
  body select {
    width: 100%;
    height: 26px;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body select:hover {
    border: solid 1px #0004;
  }
  
  body select:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  
  body textarea {
    width: 100%;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
    resize: none;
  }

  body textarea:hover {
    border: solid 1px #0004;
  }
  
  body textarea:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  /* -- Toolbar CSS -- */
  .pagerToolbar {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-shadow: 0 0 4px #0008;
    z-index: 50;
    user-select: none;
    overflow-x: auto;
    white-space: nowrap;
  }

  .pagerToolbar * {
    pointer-events: all;
  }

  .pagerRow {
    width: 100%;
    height: auto;
    margin: 4px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .pagerCol {
    width: auto;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .pagerToolbarFunctions {
    width: auto;
    height: 100%;
    padding: 4px;
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  .pagerToolbarCol {
    width: auto;
    height: 100%;
    max-width: 120px;
    padding: 4px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .pagerToolbarFunctionsBtn {
    width: 100%;
    margin: 0 0 4px 0;
  }

  .pagerToolbarSection {
    width: auto;
    height: 100%;
    padding: 0 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    border: solid 1px #0001;
  }

  .pagerToolbarSectionTitle {
    width: 100%;
    height: 24px;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    color: #000A;
    user-select: none;
  }

  .pagerTextFamily {
    width: 140px;
  }

  .pagerTextSize {
    width: 50px;
    margin: 0 0 0 10px;
  }

  .pagerTextColor {
    width: 52px;
  }

  .pagerFormSelect {
    width: 200px;
  }

  .pagerJsonSelect {
    width: 200px;
  }


  /* -- Pager Content CSS -- */
  .pagerContent {
    width: 100%;
    height: auto;
    padding: 40px 0 0 0;
    flex: 1;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: #eeef;
    overflow: scroll;
    user-select: none;
  }

  .pagerContent > .pageViewer > .pageMain, .pagePlaceholder {
    margin: 0 auto 20px auto;
    box-shadow: 0 0 4px #0004;
  }

  .pageViewer {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .pageMargin {
    width: auto;
    height: 100%;
    margin: 0 auto;
  }

  .pageMain {
    flex: 0 0 auto;
    position: relative;
    background-color: #ffff;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center;
    user-select: none;
    z-index: 10;
  }

  .pageNumber {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .pageField {
    z-index: 10;
    position: absolute;
  }

  .pageField.selected {
    box-shadow: 0 0 4px #0008;
  }
  
  .pagePlaceholder {
    flex: 0 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff8;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center;
    user-select: none;
    pointer-events: none;
    z-index: 10;
  }

  .pagePlaceholderText {
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffff;
    color: #0008;
    border: solid 1px #0004;
  }

  /* -- Editor CSS -- */
  .editorMain {
    min-width: 10px;
    min-height: 10px;
    position: absolute;
    border: solid 1px #0008;
    user-select: none;
    pointer-events: none;
    z-index: 20;
  }

  .editorResize {
    width: 20px;
    height: 20px;
    min-width: 10px;
    min-height: 10px;
    position: absolute;
    bottom: -10px;
    right: -10px;
    border: solid 1px red;
    border-radius: 100%;
    pointer-events: all;
    cursor: nw-resize;
  }

  .editorTextMain {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }

  .editorText {
    width: 350px;
    height: 100px;
    padding: 5px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #444f;
    border: solid 1px #0008;
  }

  .editorTextarea {
    width: auto;
    height: 100%;
    flex: 1;
  }

  .editorTextselect {
    width: 100px;
    height: 100%;
    margin: 0 0 0 6px;
  }

  .editorTableMain {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }

  .editorTableCellKeys {
    position: absolute;
    top: -40px;
    left: -1px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .editorTable {
    width: 350px;
    height: auto;
    padding: 5px 5px 1px 5px;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: #444f;
    border: solid 1px #0008;
  }

  .editorTableRow {
    width: 100%;
    height: auto;
    margin: 0 0 4px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .editorTableCol {
    width: 50%;
    height: auto;
    margin: 0 0 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .editorTableLabel {
    width: auto;
    height: 100%;
    padding: 0 4px 0 9px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #ffff;
  }

  .editorTableInput {
    width: 80px;
  }

  .editorTableselect {
    width: auto;
    flex: 1;
  }

  .editorTableSeq {
    width: auto;
    height: auto;
    position: absolute;
    top: -1px;
    bottom: 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    background-color: #444f;
    border: solid 1px #0008;
  }

  .editorTableSeqLabel {
    width: auto;
    height: auto;
    padding: 0 4px;
    flex: 1;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffff;
  }

  .editorTableFunctions {
    width: auto;
    height: auto;
    padding: 5px;
    position: absolute;
    top: -1px;
    bottom: 0px;
    right: 355px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: #444f;
    border: solid 1px #0008;
  }

  .editorPageMain {
    width: auto;
    height: auto;
    padding: 5px;
    position: absolute;
    right: 0px;
    background-color: #444f;
    border: solid 1px #0008;
    overflow: hidden;
    z-index: 20;
  }

  .editorPageLabel {
    width: 100%;
    height: 20px;
    margin: 0 0 5px 0;
    font-size: 12px;
    color: #ffff;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  .editorPageBtn {
    width: auto;
  }

  /* -- Save CSS -- */
  .pagerSaveMain {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 900;
  }

  .pagerSave {
    width: 340px;
    height: 200px;
    padding: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: #ffff;
    border-radius: 4px;
    box-shadow: 0 0 8px #0004;
  }

  .pagerSaveTitle {
    width: 100%;
    height: 24px;
    font-size: 12px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  .pagerSaveInput {
    width: 100%;
    margin: 0 0 4px 0;
  }

  .pagerSaveList {
    width: 100%;
    height: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border-top: solid 1px #0001;
    border-left: solid 1px #0001;
    overflow-y: scroll;
  }

  .pagerSaveItem {
    width: 100%;
    height: 18px;
    min-height: 18px;
    padding: 0 4px;
    margin: 0 0 2px 0;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: solid 1px #0001;
    user-select: none;
    color: #888f;
  }

  .pagerSaveFunctions {
    width: 100%;
    height: auto;
    margin: 4px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .pagerSaveFunctionsBtn {
    width: auto;
    margin: 0 0 0 4px;
  }

  .pagerSaveReminder {
    width: auto;
    padding: 0 4px;
    font-size: 10px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;
    color: red;
  }

</style>